import Index from '../views/index/index.vue'
import Login from '../views/login/login.vue'
import WX_Delivery from '../views/delivery/wx-delivery-list'
import ZBZ_Delivery from '../views/delivery/zbz-delivery-list'
import JX_Delivery from '../views/delivery/jx-delivery-list'
import LYD_Delivery from '../views/delivery/ldy-delivery-list'
import TOP_Delivery from '../views/delivery/top-delivery-list'
import GJ_Delivery from '../views/delivery/gj-delivery-list'
import JYA_Delivery from '../views/delivery/jya-delivery-list'
const getViewComponent = (path) => (resolve) => require(['@/views' + path + '.vue'], resolve)

export default [{
	path: '/index',
	name: 'Index',
	component: Index,
	children: [
		{
			path: '/report/files',
			component: getViewComponent('/report/files'),
			meta: {
				title: '报告上传'
			}
		},
		{
			path: '/sample/detail',
			component: getViewComponent('/sample/detail'),
			meta: {
				title: '订单详细信息'
			}
		},
		{
			path: '/report/manage',
			component: getViewComponent('/report/manage'),
			meta: {
				title: '报告管理'
			}
		},
		{
			path: '/report/bill',
			component: getViewComponent('/report/bill'),
			meta: {
				title: '发票信息'
			}
		},
		{
			path: '/report/send',
			component: getViewComponent('/report/send'),
			meta: {
				title: '报告寄送'
			}
		},
		{
			path: '/sample/list',
			component: getViewComponent('/sample/list'),
			meta: {
				title: '样本管理'
			}
		},
		{
			path: '/index/wx-delivery',
			component: WX_Delivery,
		}, {
			path: '/index/zbz-delivery',
			component: ZBZ_Delivery,
		}, {
			path: '/index/jx-delivery',
			component: JX_Delivery,
		},
		{
			path: '/index/ldy-delivery',
			component: LYD_Delivery,
		},
		{
			path: '/index/top-delivery',
			component: TOP_Delivery,
		},
		{
			path: '/index/gj-delivery',
			component: GJ_Delivery,
		},
		{
			path: '/index/jya-delivery',
			component: JYA_Delivery,
		},
	]
}, {
	path: '/login',
	name: 'Login',
	component: Login,
}, {
	path: '/',
	name: 'Index',
	component: Index,
}]



// WEBPACK FOOTER //
// ./src/router/config.js